import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-panel-icon",
  "use": "icon-panel-icon-usage",
  "viewBox": "0 0 14.142 14.142",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.142 14.142\" id=\"icon-panel-icon\"><defs><style>#icon-panel-icon .a{fill: rgb(18,88,188);}</style></defs><rect class=\"a\" width=\"10\" height=\"10\" rx=\"2\" transform=\"translate(7.071) rotate(45)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol